import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import {Validators, FormBuilder, FormGroup } from '@angular/forms';
import {MydataService} from '../home/mydata.service';
import {MyUrlService} from '../home/checkUrll';
import {MyvariableService} from '../home/constantvariable';
import {JsonData} from '../home/dataaa';
import {HomePage} from "../home/home";
import { AlertController } from 'ionic-angular';
import {SignUpPage} from "../signup/signup";
import {OtpPage} from "../otp/otp";
import {DeliveryPage} from "../delivery/delivery";
import { LoadingController } from 'ionic-angular';
import {MycartPage} from "../mycart/mycart";


@Component({
	selector: 'page-login',
	templateUrl: 'login.html',
	providers:[MydataService,MyUrlService,JsonData,MyvariableService]
})
export class LoginPage {
	jsonDt : Array<JsonData>;
	private todos : FormGroup;
	private specialKeys: Array<string> = [ 'Backspace', 'Tab', 'End', 'Home' ];
	LOGINFORGOT= this.MyvariableService.LOGINFORGOT;


	constructor(public loginCtrl: NavController,public loading: LoadingController,public alerCtrl: AlertController,private formBuilder: FormBuilder, private myurlService: MyUrlService,private mydataService: MydataService,private MyvariableService: MyvariableService) {

		this.todos  = this.formBuilder.group({
			user: ['',Validators.required],
			pass:['',Validators.required],
		});
	}

	logForm()
	{

		var userid=window.localStorage.getItem('userid');
		//alert(userid);
		if(this.mydataService.checkInternetFunction()=="0"){
			////console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1"){
			var kiloSabjiJSONdata = JSON.stringify(this.todos.value);
			//console.log("Button Click"+"\n"+"kilo Sabji Url--->"+this.myurlService.LOGINURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
      let loader = this.loading.create({content: '',});
      loader.present().then(() => {
        this.mydataService.postJSON(this.myurlService.LOGINURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.loginService(loader));

      });
		}
	}

	errorFunction= function(loader,error){
		loader.dismiss();
		//console.log(error);
		//alert(error);
		}
  loginService=function(loader){
		//console.log("jsondata ==>"+JSON.stringify(this.jsonDt.logindata));

		let uid = this.jsonDt.logindata;
		this.LOGINMSG= this.MyvariableService.LOGINMSG;
		//alert(msg);
		//alert(uid);
    loader.dismiss();
	if(uid!=''){
			window.localStorage.setItem('userid',  uid);
			var check=window.localStorage.getItem('chekout');
			if(check=='1'){
				this.loginCtrl.push(DeliveryPage);
			}
			else
			{
				this.userids=window.localStorage.getItem('userid');
		 //alert(this.userids);
				this.loginCtrl.push(HomePage);
			}
			}else{
			//alert(msg);
			this.showAlert();
		}


	}


	_keyPress(event: any) {
		const pattern = /[0-9\ ]/;
		let inputChar = String.fromCharCode(event.charCode);

		if (!pattern.test(inputChar)) {

			if(this.specialKeys.indexOf(event.key) !== -1)
			{
				return;
				// invalid character, prevent input

			}
			//alert('Enter The Number');
			event.preventDefault();
		}
	}


	showAlert=function() {

		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: this.LOGINMSG,
			buttons: ['OK']
		});
		alert.present();
	}
	itemSelected()
	{
		this.loginCtrl.push(HomePage);
	}
	signup()
	{
		this.loginCtrl.push(SignUpPage);
	}

	forgotpass(mobile)
	{
		//alert(mobile);
		if(mobile!=''){

			//console.log(mobile);
			if(this.mydataService.checkInternetFunction()=="0"){
				////console.log("Internet UnAvailable")
				}else  if(this.mydataService.checkInternetFunction()=="1"){
				var kiloSabjiJSONdata = JSON.stringify({"mobileno":mobile});
				//console.log("Button Click"+"\n"+"kilo Sabji Url--->"+this.myurlService.FORGOTPASS+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
        let loader = this.loading.create({content: '',});
        loader.present().then(() => {
          this.mydataService.postJSON(this.myurlService.FORGOTPASS ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.forgotPassService(loader));
        });
			}
			}else{
			this.showAlertotp();
		}
	}

  forgotPassService=function(loader){
		//console.log("jsondata ==>"+JSON.stringify(this.jsonDt));
		//alert(JSON.stringify(this.jsonDt));

		let uid = this.jsonDt.sinupdata;
		let msg = this.jsonDt.msg;
		this.LOGINFORGOTWRONG= this.MyvariableService.LOGINFORGOTWRONG;
		// alert(uid);
    loader.dismiss();
		if(uid!=''){
			window.localStorage.setItem('sinupid',  uid);
			window.localStorage.setItem('phoneno',  msg);

			var xyz = window.localStorage.getItem('sinupid');
				window.localStorage.setItem('otpTypee','changepass');
			// alert(JSON.stringify(xyz));
			this.loginCtrl.push(OtpPage);
			}else{
			this.showAlerwrongmobile();
		}
	}

	showAlertotp=function() {

		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: this.LOGINFORGOT,
			buttons: ['OK']
		});
		alert.present();
	}

	showAlerwrongmobile=function() {

		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: this.LOGINFORGOTWRONG,
			buttons: ['OK']
		});
		alert.present();
	}
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts